<template>
    
         <div class="modal is-active  has-modal-card margin: 0 auto "    >
           <b-loading  :active.sync="isFullScreenSearching" ></b-loading>     
         <div class="modal-background"></div>
         <div class="modal-card">
            <header class="modal-card-head">
              Genertate Report CSV 
            </header>

            <section class="modal-card-body">
              
                   <!-- {{departmentArr}} -->
                <b-field label="Year"
                      :type="{ 'is-danger': hasYearSelected }"
                      :message="{ 'required': hasYearSelected }"     
                                          
                >

                        <template #label>
                            Year
                            <span class="has-text-danger">*</span>
                        </template>


                   <b-select placeholder="Select a Year" v-model="yearSelected"  @input="inputYearSelected"  >
                    <option
                        v-for="year in yearArr"
                        :value="year"
                        :key="year">
                        {{ year }}
                    </option>
                  </b-select>
                </b-field>

                <b-field label="Department">
                    <b-select placeholder="Select a Department" v-model="departmentSelected">
                        <option
                            v-for="department in departmentArr"
                            :value="department.iddepartment"
                            :key="department.iddepartment">
                            {{ department.name }}
                        </option>
                    </b-select>
                    <p class="control">
                        <b-button type="is-danger"  icon-left="close-thick" @click="departmentSelected=null" />
                    </p>
                </b-field>


                 <!-- <b-field label="Items">
                       <template #label>
                        Items
                            <span>    
                                <b-button type="is-info" 
                                  size="is-small"
                                  icon-right="plus"
                                  @click="openReportI001_ItemsListForSelected"
                                   /></span>
                            <span v-if="partSelectedArr.length>0">    
                                <b-button type="is-danger" 
                                  size="is-small"
                                  icon-right="close"
                                  @click="partSelectedArr=[]"
                                   /></span>      
                        </template>
                       <b-taglist>
                            <b-tag 
                                v-for="partSelected in partSelectedArr" 
                                :key="partSelected.id"
                                attached
                                size="is-medium"
                                closable
                                aria-close-label="Close tag"
                                @close="closeTagItems(partSelected)">
                                {{partSelected.name_part}}
                            </b-tag>
                    </b-taglist>
                
                </b-field> -->


                <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>



            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">
                <b-button type="is-danger"
                          icon-right="close"
                          @click="close" >Cancel</b-button>


                <b-button type="is-success"
                          icon-left="share"  @click="genReport"
                           >
                    Generate and Send
                </b-button>

            </footer>
         </div>



<!-- 
         <b-modal
                v-if="isReportI001_ItemsListForSelectedShowing"
                v-model="isReportI001_ItemsListForSelectedShowing"
                has-modal-card
                full-screen
        >

            <ReportI001_ItemsListForSelected
                    v-if="isReportI001_ItemsListForSelectedShowing"
                    :isComponentModalActive ="isReportI001_ItemsListForSelectedShowing"
                    @close = "closeReportI001_ItemsListForSelected"
                    
            />
        </b-modal> -->




         </div>

</template>



<script>
import axios from "axios"
import {   getBaseURLforBackEnd  , getConfigAxios   } from '@/utils.js'
import { mapState} from "vuex";
// import ReportI001_ItemsListForSelected from '../Reports/ReportI001_ItemsListForSelected.vue'


export default {
    name : "ReportI001",
    props:{
        isComponentModalActive : Boolean,
    },
    // components:{
    //     ReportI001_ItemsListForSelected 
    // },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()

                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    computed:{
            ...mapState({            
                access_token : state => state.master_data.access_token,
            }) ,
    },        
    methods:{
        openReportI001_ItemsListForSelected(){
            this.isReportI001_ItemsListForSelectedShowing = true
        },
        closeReportI001_ItemsListForSelected(payload){
            console.log(payload)
            this.isReportI001_ItemsListForSelectedShowing = false
        },
        closeTagItems(payload){
            console.log(payload)
        },




        inputYearSelected(){
            if(this.yearSelected!=null){
                this.hasYearSelected = false
            }
        },
        loadYearAval(){
            const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/getdistinctyearmoveoutinventory`,getConfigAxios())
                    .then(function (response) {
                        vm.yearArr = response.data
                        vm.isFullScreenSearching = false                    
                    })
        },
        loadDepartment(){
             this.isFullScreenSearching = true
             const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/list_of_departmentappoint`,getConfigAxios())
                    .then(function (response) {
                        // console.log(response.data)
                        vm.departmentArr = response.data
                        vm.isFullScreenSearching = false
                    })
                 
        },
        // loadItems(){
        //      this.isFullScreenSearching = true
        //      const vm = this
        //         axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
        //         axios.post(`${getBaseURLforBackEnd()}/api/getdistinctpartinventory`,getConfigAxios())
        //             .then(function (response) {
        //                 // console.log(response.data)
        //                 vm.partArr = response.data
        //                 vm.isFullScreenSearching = false
        //             })
        // },
        genReport(){
            if (this.yearSelected===null){
                this.hasYearSelected = true
                return
            }
            // pass ready for request
            const datTo = {
                "year" : this.yearSelected,
                "department_id" : this.departmentSelected
            }

            // console.log(JSON.stringify(datTo))
            this.isFullScreenSearching = true
             const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/reporti01`,datTo,getConfigAxios())
                    .then( (res) => {
                      this.isFullScreenSearching = false
                      vm.$buefy.toast.open({
                            duration: 5000,
                            message: `${res.data.msg}`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                      vm.$emit('close')  
                    })
                    .catch(()=>{
                      this.isFullScreenSearching = false   
                      vm.$buefy.toast.open({
                            duration: 5000,
                            message: `something error`,
                            position: 'is-bottom',
                            type: 'is-danger'
                        })
                    })



        },
        close(){
            //    console.log("hello") 
           this.$emit('close')
        }
    },
    data(){
        return {
              departmentArr : [],
              yearArr : [],
              isFullScreenSearching : false,


              yearSelected : null ,
              departmentSelected : null ,  
              partSelectedArr : [
                                // {
                                //   "id": "100000000025",
                                //   "name_part": "(New Rx) Marbofloxacin 5 mg (Marbocyl)(กล่อง10TAB)"
                                // },
                                // {
                                //    "id": "100000000028",
                                //    "name_part": "(New Rx) Enrofloxacin 15mg(BAYTRIL 15)(กล่อง50TAB)"
                                //  },
                                //  {
                                //    "id": "100000000029",
                                //    "name_part": "(New Rx) Enrofloxacin 50mg(BAYTRIL 50)(กล่อง50TAB)"
                                // },
                                // {
                                //     "id": "100000000030",
                                //     "name_part": "(New Rx) Metronidazole 200 mg(Metrolex)(กล่อง100TAB)"
                                // },
                                // {
                                //     "id": "100000000033",
                                //     "name_part": "(New RX) Norfloxacin 100mg(NORXACIN)(กล่อง100TAB)"
                                // },
                                // {
                                //     "id": "100000000034",
                                //     "name_part": "(New RX) Norfloxacin 200mg(NORXACIN)(กล่อง160TAB)"
                                // },
                                // {
                                //     "id": "100000000035",
                                //     "name_part": "(New RX) Norfloxacin 400 mg(NORXACIN)(กล่อง160TAB)"
                                // },
                                // {
                                //     "id": "100000000036",
                                //     "name_part": "(New Rx) Norfloxacin 400 mg(Norxacin400)(กล่อง160TAB)"
                                // },
                                // {
                                //     "id": "100000000037",
                                //     "name_part": "(New Rx) Sulfa 400 mg Trimetroprim 80 mg(Sulphamet 480)(กระปุก1000TAB)"
                                // },
                                // {
                                //     "id": "100000000039",
                                //     "name_part": "(New Rx) Minocycline 50 mg(MINO)(กระปุก100CAP)"
                                // },
                                // {
                                //     "id": "100000000040",
                                //     "name_part": "(New Rx) Oxytetracycline HCl 250mg(OXYCLINE)(กระปุก500CAP)"
                                // },
                                // {
                                //     "id": "100000000041",
                                //     "name_part": "(New Rx) Tylosin tartrate 30g/ซอง(LOSIN S)"
                                // },
                                // {
                                //     "id": "100000000042",
                                //     "name_part": "(New Rx) Amylase 37.5 Diastase 25(MAGESTO-F)(กระปุก1000TAB)"
                                // },
                                // {
                                //     "id": "100000000043",
                                //     "name_part": "(New Rx) Aluminium Hydroxide (ALUTOP)(กล่อง500TAB)"
                                // },
                                // {
                                //     "id": "100000000044",
                                //     "name_part": "(STOCK) Barium Sulphate B.P.(กล่อง500กรัม)"
                                // },
                                // {
                                //     "id": "100000000045",
                                //     "name_part": "(New Rx) Enzyme 120 mg (COMBIZYM)(กล่อง100TAB)"
                                // },
              ] ,


              hasYearSelected : false,


              isReportI001_ItemsListForSelectedShowing : false,
        }
    },
    watch:{
        isComponentModalActive:{
            immediate: true,
            handler: function(val){
                if(val){
                   this.loadDepartment()  
                   this.loadYearAval()  
                //    this.loadItems()
                   //
                   this.hasYearSelected = false
                }
            }
        }
    }
}
</script>